import { computed } from "vue";
import { useStore } from "vuex";
import { NAMESPACE } from "@modules/attempt/service/attempt.constant";
import type { ContextMessage } from "@modules/conversation/types.ts";
import { AnnotationAttemptAdapter } from "@modules/annotation/types.ts";

export function useAnnotationAttemptAdapter(): AnnotationAttemptAdapter {
  const store = useStore();

  const currentAnchor = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentAnchor`]);
  const currentPageId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentPageId`]);
  const currentSectionId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentSectionId`]);
  const currentUserId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentUserId`]);
  const anchoringContextMessage = computed<ContextMessage | null>(
    () => store.getters[`${NAMESPACE.ATTEMPT}/getAnchoringContextMessage`],
  );
  const isPreviewMode = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/isPreviewMode`]);
  const isStudentStudentView = computed(
    () => store.getters[`${NAMESPACE.ATTEMPT}/isStudentStudentView`],
  );
  const isTeacherStudentView = computed(
    () => store.getters[`${NAMESPACE.ATTEMPT}/isTeacherStudentView`],
  );
  const isEAssessment = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/isEAssessment`]);
  const setAnchoringContextMessage = (payload: ContextMessage | null): Promise<unknown> =>
    store.dispatch(`${NAMESPACE.ATTEMPT}/setAnchoringContextMessage`, payload);

  return {
    currentAnchor,
    currentPageId,
    currentSectionId,
    currentUserId,
    anchoringContextMessage,
    isPreviewMode,
    isStudentStudentView,
    isTeacherStudentView,
    isEAssessment,
    setAnchoringContextMessage,
  };
}
